import React, { useRef, useEffect } from "react";
import FitOptions from "./FitOptions";
import "./fit.scss";

function FitSection({ onHeightChange }) {
  const fitWindowRef = useRef(null);

  useEffect(() => {
    if (fitWindowRef.current && onHeightChange) {
      onHeightChange(fitWindowRef.current.offsetHeight);
    }
  }, [onHeightChange]);

  return (
    <div className="fitSection" ref={fitWindowRef}>
      <div className="container">
        <FitOptions closeModal={() => {}} onHeightChange={onHeightChange} />
      </div>
    </div>
  );
}

export default FitSection;
